import type { Dispatch } from "redux";
import getAxios from "../../services/axios";
import type { WhiteLabelAction } from "./consts";
import { isGsDomain } from "services/whiteLabels";
import type { Whitelabel } from "@gs/core/domain/Whitelabel/Whitelabel";

const axios = getAxios("idV2");

export const loadWhiteLabelLogos = (domain: string) => async (dispatch: Dispatch<WhiteLabelAction>) => {
  dispatch({
    type: "WHITE_LABEL_REQUEST_STARTED",
  });

  if (isGsDomain()) {
    // @ts-ignore
    return dispatch({
      type: "WHITE_LABEL_REQUEST_SUCCESS",
      // fullLogoUrl: res.logo,
      // squareLogoUrl: res.square_logo,
      companyName: "GetSales",
      terms: "https://getsales.io/terms-conditions",
      // intercomAppId: res.config?.intercom_app_id,
      // salesEmail: res.config?.sales_email,
      // onboardingSteps: res.config?.onboarding,
    });
  }

  try {
    const res: Whitelabel = await axios.get(`/api/whitelabels/by-domain/${domain}`);

    if (!res) {
      return dispatch({
        type: "WHITE_LABEL_REQUEST_SUCCESS_EMPTY",
      });
    }

    dispatch({
      type: "WHITE_LABEL_REQUEST_SUCCESS",
      fullLogoUrl: res.logo,
      squareLogoUrl: res.square_logo,
      companyName: res.company_name,
      terms: res.config?.terms,
      intercomAppId: res.config?.intercom_app_id,
      salesEmail: res.config?.sales_email,
      onboardingSteps: res.config?.onboarding,
      qualificationQuestions: res.config?.qualification_questions,
      payment: res.config?.payment,
    });
  } catch {
    dispatch({
      type: "WHITE_LABEL_REQUEST_FAILED",
    });
  }
};
